import React, { FC } from "react";
import { Button } from "theme-ui";
import { Variants } from "../..";
import { ButtonSliderDefaultProps, ButtonSliderProps } from "./link";

export const LinkButtonSlider: FC<ButtonSliderProps> = ({
  left,
  children,
  ...props
}: ButtonSliderProps) => (
  <Button variant="buttons.slider.default" as="a" {...props}>
    <div>
      <Variants.IconMedium
        noPrimary
        hasBg={false}
        icon={left ? "arrow-left" : "arrow-right"}
      />
    </div>
    {children}
  </Button>
);
LinkButtonSlider.defaultProps = ButtonSliderDefaultProps;
